export default __webpack_public_path__ + "static/media/partner-red-star.15656885.webp";